import { EditorNavbar as Navbar } from '@carboncopyco/editor-sdk';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { useFlagsFallback } from '../../hooks/useFlagsFallback';
import { useNavigation } from '../../hooks/useNavigation';

export interface EditorNavigationProps {
  tab: IGlobalTab;
  url: string;
}

export const EditorNavigation = ({ tab, url }: EditorNavigationProps) => {
  const { canGoBack, canGoForward, goBack, goForward, isLoading } =
    useNavigation(tab);
  const { editorRefreshPage } = useFlagsFallback();

  return (
    <Navbar.Navigation
      url={url}
      disabledBack={!canGoBack}
      disabledForward={!canGoForward}
      onBack={goBack}
      onForward={goForward}
      onReload={
        editorRefreshPage
          ? () => {
              window.dsDesktop.navigation.reload();
            }
          : undefined
      }
      onStopReload={
        editorRefreshPage
          ? () => {
              window.dsDesktop.navigation.stopReload();
            }
          : undefined
      }
      isLoading={isLoading}
    />
  );
};
